<template>
  <div>
    <Main :loading="loading" :tableData="tableData" @reload="getData">
      <template #header>
        <div class="d-flex align-items-center">
          <div class="mb-0 mt-0" style="font-size: 18px; color: #2b3447">
            {{ displayTitle }}
          </div>
          <div v-if="!disabled" class="d-flex align-items-center">
            <el-divider direction="vertical"></el-divider>
            <b-button
              size="sm"
              variant="outline-success"
              @click="editOpts.visible = true"
            >
              {{ displayBtnText }}
            </b-button>
          </div>
        </div>
      </template>
    </Main>

    <EditCategoryOptions
      :visible.sync="editOpts.visible"
      :dfDefinitionCode="dfDefinitionCode"
      :dfCategoryNo="dfCategoryNo"
      @reload="getData"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import EditCategoryOptions from '../edit-category-options'
export default {
  components: { Main, EditCategoryOptions },
  props: {
    dfDefinitionCode: { type: String, default: '' },
    dfCategoryNo: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      editOpts: { visible: false },
    }
  },
  computed: {
    displayTitle() {
      return this.$l(
        ['table_title_categoryOptions', this.dfCategoryNo]
          .filter(Boolean)
          .join('_')
      )
    },
    displayBtnText() {
      return this.$l(
        ['btn_edit_categoryOptions', this.dfCategoryNo]
          .filter(Boolean)
          .join('_')
      )
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.dfDefinitionCode || !this.dfCategoryNo) return

      this.loading = true
      const res = await this.$api
        .dfDefinitionCategoryListApi({
          dfDefinitionCode: this.dfDefinitionCode,
          dfCategoryNo: this.dfCategoryNo,
        })
        .catch(() => null)
      this.loading = false

      this.tableData = res?.body?.data || []
    },
  },
}
</script>
